// Deterministic "good/borderline" signal so UI can badge offers.
// Later replace with partner APIs or your own risk engine.
export type Eligibility = "good" | "borderline" | "unknown";

export function estimateEligibility(amountAED: number): Eligibility {
  if (amountAED < 15000) return "good";
  if (amountAED <= 60000) return "borderline";
  return "unknown";
}